import _slicedToArray from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Field } from "redux-form";
import { required } from '@defi/core-utils';
var MASKED_STRING = "*****";

var MaskingWrapper = function MaskingWrapper(props) {
  var col = props.col,
      component = props.component,
      editStatus = props.editStatus,
      context = props.context,
      name = props.name,
      isRequired = props.isRequired,
      value = props.value,
      isActive = props.isActive;
  var mode = col.get('MaskingMode');

  if (mode !== 0) {
    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        clicked = _useState2[0],
        setClick = _useState2[1];

    var title = col.get('MaskingMode') === 1 ? "Click to unmask" : '';
    var elemtValue = value || col.get('Value');

    var renderBlankField = function renderBlankField(prop) {
      var name = prop.input.name,
          _prop$meta = prop.meta,
          touched = _prop$meta.touched,
          error = _prop$meta.error;
      var showError = touched && error;
      return showError ? component({
        name: name,
        error: error,
        value: ""
      }) : component({
        name: name,
        error: "",
        value: ""
      });
    };

    if (elemtValue !== "") {
      if ((mode === 1 || mode === 2) && !clicked) {
        var style = {
          cursor: mode === 1 ? 'pointer' : 'auto',
          pointerEvents: 'auto'
        };
        return React.createElement(Tooltip, {
          title: title,
          placement: "right",
          onClick: function onClick() {
            if (mode !== 2) setClick(true);
          }
        }, component ? component({
          name: "",
          error: "",
          value: MASKED_STRING,
          style: style
        }) : React.createElement("span", null, MASKED_STRING));
      }
    } else if (mode === 2 && editStatus) {
      var elementId = String(col.get('ElementId'));
      var fieldName = name || String('de-' + col.get('DataElement').get('Id'));
      return isActive ? React.createElement(Field, {
        id: elementId,
        name: fieldName,
        component: renderBlankField,
        context: context,
        validate: isRequired ? [required] : []
      }) : null;
    }
  }

  return props.children;
};

MaskingWrapper.defaultProps = {
  editStatus: false
};
export default MaskingWrapper;